export class RateioTemplatesFactory {
  constructor(instance) {
    this.instance = instance;
  }

  list(filter) {
    return this.instance.get('v1/financeiro/rateio-templates', {
      params: filter || {},
    });
  }

  show(id) {
    return this.instance.get(`v1/financeiro/rateio-templates/${id}`);
  }

  insert(data) {
    return this.instance.post('v1/financeiro/rateio-templates', data);
  }

  update(id, data) {
    return this.instance.put(`v1/financeiro/rateio-templates/${id}`, data);
  }

  remove(id) {
    return this.instance.delete(`v1/financeiro/rateio-templates/${id}`);
  }
}

export default (...params) => new RateioTemplatesFactory(...params);
